// extracted by mini-css-extract-plugin
export default {"wrapper":"_EdaMy01WrzX4tSm4pPt"};